import { Component, Input, OnInit } from '@angular/core';
import { ChartConfiguration, ChartType } from 'chart.js';

@Component({
    selector: 'app-line-chart',
    templateUrl: './line-chart.component.html',
    styleUrls: ['./line-chart.component.css']
})
export class LineChartComponent implements OnInit {
    @Input() chartData;
    @Input() chartLabels: string[];
    lineChartData: ChartConfiguration['data'];
    lineChartOptions: ChartConfiguration['options'] | any;
    lineChartType: ChartType = 'line';

    constructor() {}

    ngOnInit(): void {
        this.customChartOptions();
        this.setChartData();
    }

    setChartData() {
        const dataset = [];
        this.chartData.forEach(element => {
            const dataObj = {
                data: element.data,
                label: element.label,
                backgroundColor: element.color,
                borderColor: element.color,
                pointBackgroundColor: 'transparent'
            };

            dataset.push(dataObj);
        });

        this.lineChartData = { datasets: dataset, labels: this.chartLabels };
    }

    customChartOptions() {
        this.lineChartOptions = {
            responsive: true,
            maintainAspectRatio: false,
            pointBorderColor: 'transparent',
            pointHoverBackgroundColor: '#ff375e',
            pointHoverBorderColor: '#fff',
            pointHoverBorderWidth: 3,
            pointHoverRadius: 9,
            elements: {
                line: {
                    tension: 0
                }
            },
            scales: {
                x: {
                    grid: { display: true, lineWidth: 5, color: '#f8f9fa' },
                    border: { color: 'transparent' }
                },
                y: {
                    beginAtZero: true,
                    display: false,
                    grid: { display: false }
                }
            },
            plugins: {
                legend: {
                    display: false,
                    onClick: e => e.stopPropagation(),
                    position: 'top',
                    align: 'start',
                    rtl: true,
                    labels: {
                        color: '#707070',
                        boxWidth: 15,
                        boxHeight: 15,
                        padding: 10
                    }
                },
                tooltip: {
                    callbacks: {
                        title: function (context) {
                            return '';
                        }
                    },
                    backgroundColor: '#4f008c',
                    bodyAlign: 'right',
                    bodyFont: { size: 16, family: 'STCForward-Regular' },
                    displayColors: false,
                    padding: { top: 15, right: 20, left: 20, bottom: 10 }
                }
            }
        };
    }
}
